export class SiFile {
  id?: number;
  name?: string;
  url?: string; // Use this attribute to set the complete url.
  fileId?: string; // Use this attribute to set the id of the file as partial url.
  type?: string;
}
